import { DASHBOARD_PANEL_HEADER_CLASS } from "../_utils/dashboardPanelStyles";
import { getTodoPanelDescription } from "../_utils/todoPanelVisibility";

type DashboardTasksPanelHeaderProps = {
  canViewTasks?: boolean;
  showMyTasks?: boolean;
  showTeamTasks?: boolean;
  showChangeRequestsSection?: boolean;
};

export default function DashboardTasksPanelHeader({
  canViewTasks = true,
  showMyTasks = false,
  showTeamTasks = false,
  showChangeRequestsSection = false
}: DashboardTasksPanelHeaderProps) {
  const description = getTodoPanelDescription({
    showMyTasks: canViewTasks && showMyTasks,
    showTeamTasks: canViewTasks && showTeamTasks,
    showChangeRequestsSection
  });

  return (
    <div className={DASHBOARD_PANEL_HEADER_CLASS}>
      <div className="min-w-0">
        <h2 className="!m-0 text-title-medium-bold text-sys-brand-on-surface">To Do</h2>
        {description ? (
          <p className="mt-1 text-body-medium text-sys-brand-on-surface-variant" data-testid="tasks-scope-description">
            {description}
          </p>
        ) : null}
      </div>
    </div>
  );
}
